<script>
	import SvelteTable from "svelte-table";
	import { onMount } from 'svelte'
	import Papa from 'papaparse'
	let data = [];
	let error = {};

	onMount(async () => {
		Papa.parse('https://docs.google.com/spreadsheets/d/e/2PACX-1vRlsMvY7HIL_6VpoaVHxW4WdgJMwfX2YeGrIvU_I3wzUT0cLFOFLIw_y0WQ4lKiHdz36nnV46s4JipH/pub?gid=0&single=true&output=csv', {
			download: true,
			header: true,
			skipEmptyLines: true,
			complete: function (results) {
				data = results.data
				console.log(data)
			},
			error: function (err) {
				error = err
				console.log(err)
			}
		})
	})

	const columns = [
		{
			key: "Start Date",
			title: "Start Date",
			value: row => row["Start Date"],
			sortable: true,
			searchValue: row => row["Start Date"],
		},
		{
			key: "End Date",
			title: "End Date",
			value: row => row["End Date"],
			sortable: true,
			searchValue: row => row["End Date"],
		},
		{
			key: "Person(s) involved",
			title: "Person(s) involved",
			value: row => row["Person(s) involved"],
			sortable: true,
			searchValue: row => row["Person(s) involved"],
		},
		{
			key: "Grant/Award Title",
			title: "Grant/Award Title",
			value: row => row["Grant/Award Title"],
			sortable: true,
			searchValue: row => row["Grant/Award Title"],
		},
		{
			key: "Dollar amount",
			title: "Dollar amount",
			value: row => row["Dollar amount"],
			sortable: true,
			searchValue: row => row["Dollar amount"],
		},
		{
			key: "Organization",
			title: "Organization",
			value: row => row["Organization"],
			sortable: true,
			searchValue: row => row["Organization"],
		},
	];
</script>

<main>
	{#await data}
	<p>...waiting</p>
	{:then data}
	<nav class="teal darken-2">
		<div class="nav-wrapper teal darken-2">
			<h5 class="brand-logo">University Libraries Grants and Awards</h5>
			<ul id="nav-mobile" class="right hide-on-med-and-down">
				<li>
					<h5>{data.length} total grants</h5>
				</li>
			</ul>
		</div>
	</nav>
	<!-- beautify ignore:start -->
	<SvelteTable columns="{columns}" rows="{data}" sortBy="{'Start Date'}" classNameTable={['table highlight']} classNameThead="vt-th"></SvelteTable>
		<!-- beautify ignore:end -->
	{:catch error}
	<p style="color: red">{error.message}</p>
	{/await}
</main>
<div data-iframe-height></div>

<style>
	main {
		width: 100%;
	}

	nav .brand-logo {
		width: 90%;
	}

	@media only screen and (max-width: 595px) {
		nav {
			min-height: 56px;
			height: 100px;
		}
	}

	.nav-wrapper {
		padding: 0 1em;
	}

	.vt-th {
		text-transform: uppercase;
		background-color: #faf9fa;
		letter-spacing: 0.075em;
	}

	.vt-table {
		font-family: gineso-condensed, sans-serif;
		color: #000;
		font-size: 0.67em;
		line-height: 1.4;
		font-weight: 400;
	}
</style>